import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import PlaceholderMarquee from './plugins/placeholderMarquee'
import sentry from './plugins/sentry'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// @ts-ignore
import VueDOMPurifyHTML from 'vue-dompurify-html'

import MorphemeUI from '@morpheme/ui'

import App from './App.vue'
import router from './router'

import 'nprogress/nprogress.css'
import '@vuepic/vue-datepicker/dist/main.css'

// load CSS bundle
import '@morpheme/themes/dist/morpheme/main.css'

const app = createApp(App)
const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

app.use(sentry)
app.use(VueDOMPurifyHTML)
app.use(MorphemeUI)
app.use(pinia)
app.use(router)
app.use(VueQueryPlugin)
app.use(PlaceholderMarquee)

app.mount('#app')
